module.exports = __webpack_public_path__ + "media/images/about/b_1-bc4b9f3ff772bf5a92f722faffab5842.png";